import { Directive } from '@angular/core';

@Directive({
  selector: '[fcPrefix]',
  host: {
    class: 'fc-prefix',
  },
})
export class PrefixDirective {}
